import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CheckCircle2Icon, XIcon } from "lucide-react";
import { images, recentBuyers } from "../data/content";
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [minutesAgo, setMinutesAgo] = useState(2);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    const show = () => {
      setMinutesAgo(1 + Math.floor(Math.random() * 14));
      setVisible(true);
      hideTimer = window.setTimeout(() => setVisible(false), 5000);
    };
    const first = window.setTimeout(show, 6000);
    const loop = window.setInterval(() => {
      setIndex(i => (i + 1) % recentBuyers.length);
      show();
    }, 14000);
    return () => {
      window.clearTimeout(first);
      window.clearTimeout(hideTimer);
      window.clearInterval(loop);
    };
  }, [dismissed]);
  const buyer = recentBuyers[index];
  return <div className="pointer-events-none fixed left-3 right-3 top-3 z-50 sm:left-6 sm:right-auto sm:top-auto sm:bottom-6" aria-live="polite" data-id="element-51" data-mp="163wd8szng22u">
      <AnimatePresence data-id="element-52" data-mp="1fw24u1lzohhi">
        {visible && !dismissed && <motion.div key={index} className="pointer-events-auto relative flex w-full items-center gap-3 rounded-2xl bg-white p-3 pr-9 shadow-[0_12px_40px_rgba(11,37,89,0.22)] ring-1 ring-navy/10 sm:w-[340px]" initial={{
        opacity: 0,
        y: -12,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: -12,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-53" data-mp="1fxmy7nwkhuds">
            <img src={images.mockup} alt="" className="h-14 w-14 shrink-0 rounded-xl bg-cream object-cover" data-id="element-54" data-mp="s4wsvxj669ch" />
            <div className="min-w-0" data-id="element-55" data-mp="28mkejlh7xh3w">
              <p className="text-sm font-extrabold text-navy" data-id="element-56" data-mp="23lwk0pts6i4x">
                {buyer.name} <span className="font-semibold text-ink-soft" data-id="element-57" data-mp="2aol66hya2k5d">from {buyer.country}</span>
              </p>
              <p className="text-sm leading-snug text-ink-soft" data-id="element-58" data-mp="2fneapkvl70te">just purchased the Pediatric OT Planning System™</p>
              <p className="mt-0.5 flex items-center gap-1 text-xs font-bold text-teal" data-id="element-59" data-mp="2kmhfd47nn50u">
                <CheckCircle2Icon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-60" data-mp="2pmdlb8zwx6j1" />
                {minutesAgo} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-full p-1 text-ink-soft transition-colors duration-150 hover:bg-cream hover:text-navy" aria-label="Dismiss notification" data-id="element-61" data-mp="1rzwpk86tv0ze">
              <XIcon className="h-4 w-4" data-id="element-62" data-mp="26oaq2cgrudcs" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}